import * as z from "zod/v4";

export const getUpdatedSavedEmailTemplates = {
  name: "getUpdatedSavedEmailTemplates" as const,
  input: z.object({ lastCheckedDate: z.coerce.date() }),
  output: z.object({ updatedTemplateIds: z.array(z.string()) }),
};
